import PropTypes from "prop-types";
import { Carousel } from "react-responsive-carousel";
import CarouselButton from "@/components/shared/carousel/carousel-button.jsx";

CarouselWrapper.propTypes = {
  images: PropTypes.array,
  constrainWidth: PropTypes.bool,
};

export default function CarouselWrapper({ images, constrainWidth = true }) {
  let carouselImages = [];

  if (images?.length) {
    carouselImages = images.map((image, index) => {
      const imageSource = `${image}`;
      return (
        <div key={imageSource} className="rounded-lg">
          <img alt={`Slide ${index + 1}`} src={imageSource} />
        </div>
      );
    });
  }

  if (carouselImages.length > 0) {
    return (
      <div className={`flex-grow max-w-full ${constrainWidth && "lg:max-w-screen-sm"} min-h-64`}>
        <div
          className={`bg-base-200 flex ${constrainWidth && "lg:pr-4"} select-none relative w-full}`}
        >
          <div className={`${images?.length ? "block" : "hidden"}`}>
            <Carousel
              renderArrowNext={(click, hasNext) => (
                <CarouselButton onClick={click} direction="right" enabled={hasNext} />
              )}
              renderArrowPrev={(click, hasPrev) => (
                <CarouselButton onClick={click} direction="left" enabled={hasPrev} />
              )}
              className="rounded-lg overflow-hidden"
              autoPlay={true}
              showIndicators={false}
              showStatus={false}
              infiniteLoop={true}
              showThumbs={false}
            >
              {carouselImages}
            </Carousel>
          </div>
        </div>
      </div>
    );
  }

  return null;
}
